import { baseApiClient } from "data/modules/api/api.client";
import { dataProvider } from "data";
import { apiMethods } from "data/api.constants";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { isRequestSuccessful } from "utils/Utils";
import { CHANGE_STATES } from "features/Common/modules/Form/constants/Form.constants";
import { schedule_types_ids } from "features/Listings/constants/Listings.constants";
import {
  MANAGE_OFFERING_VARIATION_BRANDED_COMMUNITY,
  UPDATE_OFFERING_VARIATION,
} from "features/OfferingVariations/OfferingVariations.apis";
import { PER_TIER_KYC_FIELD_KEYS } from "features/ManageOfferings/modules/PerTierKyc/PerTierKyc.constants";

/**
 * Thin shared API helper for persisting a variation-level KYC override.
 * Used by both the variations list hook and VariationKycContainer so the
 * persist path cannot diverge between the two call sites.
 * Pure API call — callers own processing state, notify and error logging.
 */
export const updateVariationKycOverrideApi = async ({
  offeringUuid,
  offeringType,
  record,
  override,
}) => {
  if (!record?.uuid) {
    throw new Error("Invalid variation record");
  }
  if (offeringType === schedule_types_ids.branded_community) {
    const response = await baseApiClient.post(
      MANAGE_OFFERING_VARIATION_BRANDED_COMMUNITY,
      {
        listing_uuid: offeringUuid,
        variant_membership_mappings: [
          {
            change_type: CHANGE_STATES.updated,
            uuid: record.uuid,
            membership_uuid: record?.membership_details?.uuid,
            listing_uuid: offeringUuid,
            updated_values: {
              [PER_TIER_KYC_FIELD_KEYS.KYC_OVERRIDE]: override,
            },
          },
        ],
      }
    );
    if (!isRequestSuccessful(response.status)) {
      throw new Error(response?.data?.message ?? SOMETHING_WENT_WRONG);
    }
    return response;
  }
  const response = await dataProvider.custom_request(
    UPDATE_OFFERING_VARIATION,
    apiMethods.POST,
    {
      uuid: record.uuid,
      updated_values: {
        [PER_TIER_KYC_FIELD_KEYS.KYC_OVERRIDE]: override,
      },
    }
  );
  if (!isRequestSuccessful(response.status)) {
    throw new Error(response?.message ?? SOMETHING_WENT_WRONG);
  }
  return response;
};
